import React from 'react'
import { SuccessContentWrapper } from './style'
import {
  SuccessModalContainer,
  SuccessModalBackground,
  SuccessWrapper,
  ClosedModalButton,
} from './style'
import { InvestSuccess } from 'src/assets/index'
import { InvestSuccessBtn } from 'src/components/Global/Button/Button'
import { Link } from 'react-router-dom'

const Success = ({ onIHavePaidModal, showOnIHavePaidModal }: any) => {
  const closeModal = () => {
    showOnIHavePaidModal(false)
  }
  return (
    <SuccessModalContainer>
      {onIHavePaidModal ? (
        <SuccessModalBackground>
          <SuccessWrapper>
            <ClosedModalButton onClick={closeModal} />
            <SuccessContentWrapper>
              <div className="success_svg">
                <img src={InvestSuccess} alt="" />
              </div>
              <div className="success_content">
                <div className="success_text">
                  <p className="awesome">Awesome</p>
                  <p className="process_text">
                    Your investment is being processed
                  </p>
                </div>
              </div>

              <div className="btn_wrapper">
                <Link to="/homepage">
                  <InvestSuccessBtn>Return to home</InvestSuccessBtn>
                </Link>
              </div>
            </SuccessContentWrapper>
          </SuccessWrapper>
        </SuccessModalBackground>
      ) : null}
    </SuccessModalContainer>
  )
}

export default Success
